<script lang="ts">
	import SiteOperator from "../../organisms/settings/SiteOperator.svelte";
</script>

<div class="flex">
	<div class="flex-1 mr-8">
		<SiteOperator/>
	</div>
</div>